/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_ScreeningInputs */

const en_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Review`)
};

const de_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorauswahl`)
};

const fr_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const es_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preselección`)
};

const it_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In revisione`)
};

const nl_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In behandeling`)
};

const pl_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W trakcie`)
};

const fi_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsittelyssä`)
};

const da_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under behandling`)
};

const sv_applications_status_screening = /** @type {(inputs: Applications_Status_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under granskning`)
};

/**
* | output |
* | --- |
* | "In Review" |
*
* @param {Applications_Status_ScreeningInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_screening = /** @type {((inputs?: Applications_Status_ScreeningInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_ScreeningInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_screening(inputs)
	if (locale === "fr") return fr_applications_status_screening(inputs)
	if (locale === "es") return es_applications_status_screening(inputs)
	if (locale === "it") return it_applications_status_screening(inputs)
	if (locale === "nl") return nl_applications_status_screening(inputs)
	if (locale === "pl") return pl_applications_status_screening(inputs)
	if (locale === "fi") return fi_applications_status_screening(inputs)
	if (locale === "da") return da_applications_status_screening(inputs)
	if (locale === "sv") return sv_applications_status_screening(inputs)
	return en_applications_status_screening(inputs)
});